// extracted by mini-css-extract-plugin
export default {"content":"CarouselCardSkeletion_content__hzwf2"};